// Les dictionnaires d'affichage, résolus pour la formule courante.
//
// POURQUOI DES HOOKS ET PAS DES CONSTANTES. Les libellés de statuts et
// d'événements ne disent pas la même chose aux deux produits : « Placé,
// mission signée » décrit une transaction dont le particulier n'est pas partie
// prenante. Un dictionnaire figé au chargement du module ne peut pas le savoir,
// puisque la formule vient du serveur. Ces hooks sont donc le SEUL chemin
// correct, et les constantes de `format.ts` restent exportées pour les rares
// usages hors composant (l'ORDRE du pipeline, qui ne dépend pas de la formule).

import {
  candidatureStatus,
  consultantStatus,
  eventLabels,
  type StatutCandidature,
} from './format'
import { useFormule } from './formule'
import { useLang } from './lang'

export function useCandidatureStatus(): Record<string, StatutCandidature> {
  return candidatureStatus(useFormule(), useLang())
}

export function useEventLabels(): Record<string, string> {
  return eventLabels(useFormule(), useLang())
}

export function useConsultantStatus(): Record<string, { label: string; cls: string; aide?: string }> {
  return consultantStatus(useFormule(), useLang())
}
